import { Component, OnInit, Inject } from '@angular/core';
import { Router} from "@angular/router"
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { environment } from '../../environments/environment';
import { MatDialog} from '@angular/material/dialog';
import { DlgTrabajandoComponent } from '../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../components/dlg-error/dlg-error.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    private httpClient: HttpClient,
    private router: Router,
    @Inject(SESSION_STORAGE) private storage: StorageService
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  ingresar(usuario, contrasenia){
    let dlgTrabajando = this.dialog.open(DlgTrabajandoComponent, {
      width: '600px',
      disableClose:true
    });
    dlgTrabajando.componentInstance.titulo="";
    dlgTrabajando.componentInstance.texto="Verificando usuario";

    let urlSearchParams = new URLSearchParams();
    urlSearchParams.append('usuConex', usuario);
    urlSearchParams.append('passConex', contrasenia); 
    urlSearchParams.append('entorno', "WEB"); 
    urlSearchParams.append('version', "0");    

    let parametros = urlSearchParams.toString()
    this.httpClient.post(environment.servidorHttp+'login/verificarLogin?'+parametros, null)
      .subscribe(data => {
          if (data['resultado']['msgError']['valorDevuelto']=="01"){
            let dlgError = this.dialog.open(DlgErrorComponent, {
              width: '600px',
              disableClose:true
            });
            dlgError.componentInstance.titulo="Error al verificar el usuario";
            dlgError.componentInstance.texto=data['resultado']['msgError']['mensaje'];
          }else{
            this.storage.set("token", data['resultado']['token']);            
            this.storage.set("idConexion", data['resultado']['msgError']['idConexion']);
            this.storage.set("nombreUsuario", data['resultado']['msgError']['nombreUsuario']);
            this.router.navigate(['/principal'])
          }
          this.cerrarDialogo(dlgTrabajando);
        },
        (error: HttpErrorResponse) => {
          this.cerrarDialogo(dlgTrabajando);
          let dlgError = this.dialog.open(DlgErrorComponent, {
            width: '600px',
            disableClose:true
          });
          dlgError.componentInstance.titulo="Error general al verificar el usuario";
          dlgError.componentInstance.texto=error.message+" ("+error.name+")";
        } 
      );
  }
}
